<template>
  <q-section v-bind="$attrs">
    <ui-tabs
      :tabs="[uiMeta.images.boxTab1, uiMeta.images.boxTab2]"
      :active="boxType"
      @update:model-value="handleBoxType"
      v-bind="uiMeta.layout.tabConfig" />
    <q-section
      :bg-i="uiMeta.images[`textBg${boxType + 1}`]"
      :key="`textBg${boxType + 1}`"
      v-bind="uiMeta.layout.textConfig"></q-section>
    <q-section
      :key="`value-mask-${boxType}`"
      :bg-i="uiMeta.images[boxType === 0 ? 'sendMask' : 'getMask']"
      v-bind="uiMeta.layout.valueMaskConfig">
      <q-section v-bind="uiMeta.layout.valueConfig" :key="`value-${showScore}`">{{ showScore }}</q-section>
      <q-section v-bind="uiMeta.layout.sendBtnConfig" @click="customMethod"></q-section>
    </q-section>
    <ui-progress
      :total="totalScore"
      :current="trueScore"
      v-bind="uiMeta.layout.innerProgressConfig"
      :direction="uiMeta.layout.innerProgressConfig.direction"
      :innerBg="uiMeta.images.innerProgressBg"
      :fakeLenth="fakeLenth"
      :key="`inner-progress-${fakeLenth}`" />
    <q-section
      :bg-i="uiMeta.config?.singleBg ? uiMeta.images.rewardsBg : uiMeta.images[`rewardsBg${boxType + 1}`]"
      :key="`rewardsBg${boxType + 1}`"
      v-bind="uiMeta.layout.rewardsBgConfig">
      <template v-if="!isLoadingBoxData">
        <q-section
          v-for="(item, index) in mixBtnPosition"
          :key="`mix-btn-${item.btnBg}-${index}`"
          v-bind="item.config"
          :bg-i="item.btnBg"
          @click="handleGetReward(item)"></q-section>
      </template>
    </q-section>
    <!-- 不具名插槽 兼容逻辑可以在外面处理 -->
    <slot :data="{ tab: boxType, trueScore: trueScore, totalScore: totalScore }"></slot>
  </q-section>
</template>

<script setup lang="ts">
import { useBox } from './use-box'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
  stages: {
    type: Array,
    default: () => [5000, 30000, 200000, 800000, 1500000, 3000000],
  },
  percents: {
    type: Array,
    default: () => [57, 184, 309, 436, 562, 688, 880],
  },
})
const {
  mixBtnPosition,
  trueScore,
  totalScore,
  handleGetReward,
  isLoadingBoxData,
  boxType,
  handleBoxType,
  customMethod,
  fakeLenth,
  showScore,
} = useBox(
  props.uiMeta,
  props.uiMeta?.config?.stages || (props.stages as number[]) || [],
  props.uiMeta?.config?.percents || (props.percents as number[]) || []
)

defineExpose({
  handleBoxType,
})
</script>

<style scoped lang="scss"></style>
